import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IdentityModel } from '../models/identity';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private pathAPI = environment.urlAPI;
  private controller = "Login/";
  private authenticationChanged = new Subject<boolean>();
  private identity = new BehaviorSubject<IdentityModel>(null);

  constructor(private http: HttpClient) {
    this.initializeIdentity();
  }

  public login(body: any): Observable<any> {
    let urlToken = this.pathAPI + this.controller;    
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenSeatCalc.length > 0) {
          this.setStorageToken(res.tokenSeatCalc);
          this.setStorageRefreshToken(res.refreshTokenSeatCalc);
          this.setIdentityData(this.getUserDataManual(res.tokenSeatCalc));
        }
      })
    );
  }

  public refreshToken(body: any): Observable<any> {
    let urlToken = this.pathAPI + this.controller + 'Refresh';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenSeatCalc.length > 0) {
          this.setStorageToken(res.tokenSeatCalc);
          this.setStorageRefreshToken(res.refreshTokenSeatCalc);
          this.setIdentityData(this.getUserDataManual(res.tokenSeatCalc));
        }
      })
    );
  }

  public logout(): void {
    this.setStorageToken(undefined);
  }

  setIdentityData(identy: IdentityModel) {
    this.identity.next(identy);
  }

  getIdentityData(): Observable<IdentityModel> {
    return this.identity.asObservable();
  }

  public setToken(data: any): void {
    this.setStorageToken(data.tokenSeatCalc);
    this.setStorageRefreshToken(data.refreshTokenSeatCalc);
  }

  private setStorageToken(value: any): void {
    window.localStorage['tokenSeatCalc'] = value;
    this.authenticationChanged.next(this.isAuthenticated());
  }

  private setStorageRefreshToken(value: any): void {
    window.localStorage['refreshTokenSeatCalc'] = value;
  }

  public initializeIdentity() {
    var token = this.getToken();
    if (token == null || token.trim() == '') return;
    var identity = this.getUserDataManual(token);
    this.setIdentityData(identity);
  }

  public isAuthenticated(): boolean {
    return (!(window.localStorage['tokenSeatCalc'] === undefined ||
      window.localStorage['tokenSeatCalc'] === null ||
      window.localStorage['tokenSeatCalc'] === 'null' ||
      window.localStorage['tokenSeatCalc'] === 'undefined' ||
      window.localStorage['tokenSeatCalc'] === ''));
  }

  public isAdmin(): boolean {
    return this.identity.value.IsAdmin;
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (window.localStorage['tokenSeatCalc'] === undefined ||
      window.localStorage['tokenSeatCalc'] === null ||
      window.localStorage['tokenSeatCalc'] === 'null' ||
      window.localStorage['tokenSeatCalc'] === 'undefined' ||
      window.localStorage['tokenSeatCalc'] === '') {
      return '';
    }
    let obj = window.localStorage['tokenSeatCalc'];
    return obj;
  }

  public getRefreshToken(): any {
    if (window.localStorage['refreshTokenSeatCalc'] === undefined ||
      window.localStorage['refreshTokenSeatCalc'] === null ||
      window.localStorage['refreshTokenSeatCalc'] === 'null' ||
      window.localStorage['refreshTokenSeatCalc'] === 'undefined' ||
      window.localStorage['refreshTokenSeatCalc'] === '') {
      return '';
    }
    let obj = window.localStorage['refreshTokenSeatCalc'];
    return obj;
  }

  public getUserDataManual(token) {
    if (token == null || token.trim() == '') return;
    let jwt = JSON.stringify(token);
    return this.getTokenModel(jwt);
  }

  private getTokenModel(jwt) {
    if (jwt == null || jwt.trim() == '' || jwt.trim() == "") return;
    let jwtData = jwt.split('.')[1]
    let decodedJwtJsonData = this.b64DecodeUnicode(window.atob(jwtData));
    let decodedJwtData = JSON.parse(decodedJwtJsonData);
    let userData = JSON.parse(decodedJwtData.userData);

    return userData;
  }

  private b64DecodeUnicode(str) {
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

}
